import { Component, OnInit, AfterViewInit } from "@angular/core";
import { ToggleOptions } from "../../../directives/home/toggle.directive";
import { HtmlClassService } from "../../../services/home/html-class.service";
import * as objectPath from "object-path";

@Component({
  selector: "brand",
  templateUrl: "./brand.component.html",
  styleUrls: ["./brand.component.css"]
})
export class BrandComponent implements OnInit, AfterViewInit {
  // Public properties
  headerLogo: string;
  headerStickyLogo: string;

  toggleOptions: ToggleOptions = {
    target: "body",
    targetState: "kt-aside--minimize",
    togglerState: "kt-aside__brand-aside-toggler--active"
  };

  /**
   * Component constructor
   *
   * @param layoutConfigService: LayoutConfigService
   * @param htmlClassService: HtmlClassService
   */
  constructor(public htmlClassService: HtmlClassService) {}

  /**
   * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
   */

  /**
   * On init
   */
  ngOnInit(): void {
    const config = JSON.parse(localStorage.getItem("layoutConfig"));

    this.headerLogo = this.getLogo(config);
    this.headerStickyLogo = this.getStickyLogo(config);
  }

  getLogo(config) {
    const menuAsideLeftSkin = objectPath.get(config, "brand.self.skin");
    // set brand logo
    const logoObject = objectPath.get(config, "self.logo");

    let logo;
    if (typeof logoObject === "string") {
      logo = logoObject;
    }
    if (typeof logoObject === "object") {
      logo = objectPath.get(logoObject, menuAsideLeftSkin + "");
    }
    if (typeof logo === "undefined") {
      try {
        const logos = objectPath.get(config, "self.logo");
        logo = logos[Object.keys(logos)[0]];
      } catch (e) {}
    }
    return logo;
  }

  getStickyLogo(config): string {
    let logo = objectPath.get(config, "self.logo.sticky");
    if (typeof logo === "undefined") {
      logo = this.getLogo(config);
    }
    return logo + "";
  }

  /**
   * On after view init
   */
  ngAfterViewInit(): void {}
}
